import Crud from '../components/Team/Crud.vue'
import Add from '../components/Team/Add.vue'
import Edit from '../components/Team/Edit.vue'


let routes = {
    path: '/teams',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/teams',
            name: 'Áreas',
            component: Crud
        },
        {
            path: '/teams/add',
            name: 'Nova Área',
            component: Add
        },
        {
            path: '/teams/edit/:id',
            name: 'Editar Área',
            component: Edit
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/team.js